import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M23.034 0H.966A.966.966 0 0 0 0 .966v22.068c0 .533.433.966.966.966h22.068a.966.966 0 0 0 .966-.966V.966A.966.966 0 0 0 23.034 0m-.967 22.067H1.933V1.933h20.134z\"></path><path d=\"M23.066 8.727H.966v1.933h22.1z\"></path><path d=\"M7.636 0v9.818h1.637V0zM15.273 0v9.818h1.636V0z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }